import React from 'react'
import { child_icon_3 } from '../../../icons'
import './OrderStatusPill.css'

function OrderStatusPill(props) {

    function getStatusIcon() {
        switch (props.status) {
            case "Completed":
                return <i className="bi bi-check"></i>;
            case "Approved":
                return <i className="bi bi-check"></i>;
            case "Submitted":
                return <i className="bi bi-person"></i>;
            case "Incomplete":
                return child_icon_3;
            default:
                return <i className="bi bi-person"></i>;
        }
    }

    function getStatusName() {
        switch (props.status) {
            case "Completed":
                return "Completed";
            case "Approved":
                return "Approved";
            case "Submitted":
                return "Submitted";
            case "Incomplete":
                return "Incomplete";
            case "Deleted":
                return "Canceled";
            default:
                return "Status Unknown";
        }
    }

    const statusBadgeCss = !props.short ? "status-badge" : "status-badge-short";

    return (
        <span className={`badge rounded-pill data-badge-red ${statusBadgeCss} status-badge-${props.status}`}>
            {!props.short ?
                <>
                    {/* {getStatusIcon()} */}
                    <span className='ms-1'>{getStatusName()}</span>
                </>
                :
                <>
                    {(!!props?.status && props.status.length > 0) ? Array.from(props.status)[0] : ''}
                </>
            }
        </span>
    )
}

export default OrderStatusPill